/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Bid_QueuedInputs */

const en_directory_vibebids_bid_queued = /** @type {(inputs: Directory_Vibebids_Bid_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bid queued`)
};

const zh_directory_vibebids_bid_queued = /** @type {(inputs: Directory_Vibebids_Bid_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出价已排队`)
};

/**
* | output |
* | --- |
* | "Bid queued" |
*
* @param {Directory_Vibebids_Bid_QueuedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_bid_queued = /** @type {((inputs?: Directory_Vibebids_Bid_QueuedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Bid_QueuedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_bid_queued(inputs)
	return zh_directory_vibebids_bid_queued(inputs)
});
export { directory_vibebids_bid_queued as "directory.vibebids.bid_queued" }